"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AdupLoadModel = /** @class */ (function () {
    function AdupLoadModel() {
        this.isShow = false;
    }
    return AdupLoadModel;
}());
var AdupLoad = /** @class */ (function (_super) {
    __extends(AdupLoad, _super);
    function AdupLoad(props) {
        return _super.call(this, props) || this;
    }
    AdupLoad.prototype.render = function () {
        return React.createElement("div", { style: { display: this.props.isShow ? "block" : "none" } },
            React.createElement("div", { className: "dow-adup-load" }));
    };
    return AdupLoad;
}(React.Component));
exports.AdupLoad = AdupLoad;
